enum EngineType {
  INTERNAL_COMBUSTION = 'Internal Combustion',
  ELECTRIC = 'Electric',
  INTERNAL_COMBUSTION_ELECTRIC_HYBRID = 'Internal Combustion/Electric Hybrid',
}
export default EngineType;

export type VerifyProductType = Utils.VerifyExtends<Model.Enum.EngineType, Utils.ValueOf<typeof EngineType>>;
